import type { CampaignChannelKind, CampaignRecord } from '@workspace/types';
import { CHANNEL_KIND_LABEL } from '@workspace/types';

export function campaignChannelDisplayLabel(campaign: Pick<CampaignRecord, 'channelKind' | 'deliveryMode'>): string {
  if (campaign.deliveryMode === 'CONVERSATIONAL' && campaign.channelKind === 'EMAIL') {
    return 'Email → chat web';
  }
  return CHANNEL_KIND_LABEL[campaign.channelKind];
}

export function campaignEndsAtDateLabel(endsAt: string): string {
  const day = endsAt.slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(day)) {
    return 'Vencimiento sin definir';
  }
  const [year, month, date] = day.split('-');
  return `Vence el ${date}/${month}/${year}`;
}

export function reachabilityMissingFieldLabel(channelKind: CampaignChannelKind): string {
  return channelKind === 'EMAIL' ? 'email' : 'teléfono';
}
